/* globals sage */
import Modals from '../blocks/modals.js'
import Helper from '../utils/helper.js'

const userID = sage.user_id
export default {
  isLoading: false,
  ids_post: [],
  buttons: [],
  is_connected: false,
  init () {
    // Access the user ID
    this.is_connected = userID !== '0'

    $('.button-favoris').each((favIndex, favElement) => {
      const $favElement = $(favElement)

      /* récuperation des post id */
      const postId = $favElement.attr('data-id')
      this.buttons[postId] = $favElement
      this.ids_post.push(postId)
      $favElement.click(event => {
        this.handleClickFavoris($favElement)
      })
    })

    setTimeout(() => {
      this.calculPodcastHeight()
    }, 1000)
  },

  calculPodcastHeight () {
    const $podcastContainers = $('.card-document.card-document .card-document-iframe')
    $podcastContainers.each((index, container) => {
      const $container = $(container)
      const innerWidth = $container.innerWidth() + 10
      const W = 500
      const H = 225
      const scale = innerWidth / W
      const height = H * scale

      $container.find('.card-document-iframe-inner').css(
        {
          transform: 'scale(' + scale + ')',
          height: height + 125
        })
      $container.css(
        {
          'padding-top': height + 'px'
        }
      )
    })
  },

  handleClickFavoris ($favElement) {
    const dataId = $favElement.attr('data-id')

    this.loading(true)

    if (this.is_connected) {
      $.ajax({
        method: 'POST',
        url: sage.ajax_url,
        data: { post_id: dataId, action: 'switch_favoris' }
      })
        .done(result => {
          console.log(result)
          if (result !== '0') {
            this.updateButtonView($favElement, result.data.is_favoris)
            this.loading(false)
            if (result.data.is_favoris) {
              this.handleFirstAdd()
            }
          } else {
            const modal = new Modals()
            modal.openModal('favoris-not-logged-in')
          }
        })
    } else {
      const modal = new Modals()
      modal.openModal('favoris-not-logged-in')
    }
  },

  handleFirstAdd () {
    if (Helper.getCookie('favoris-first-add') !== 'true') {
      const modal = new Modals()
      modal.openModal('favoris-first-add')
      Helper.setCookie('favoris-first-add', 'true', Number.MAX_SAFE_INTEGER)
    }
  },

  loading (isLoading) {
    this.isLoading = isLoading
  },
  updateButtonView ($button, isFavoris) {
    if (isFavoris) {
      $button.addClass('favoris')
      // $(".button-favoris-label").text("Retirer des favoris");
    } else {
      // $(".button-favoris-label").text("Ajouter aux favoris");
      $button.removeClass('favoris')
    }
  }
}
